import { detail } from './detail';

export const homes = {
    routeTitle: '场所',
    route: '场所',
    listOfHomes: '场所列表',
    addHome: '添加场所',
    editHome: '编辑场所',
    invitationSuccesfullySent: '成功发送邀请.',
    addHomeResident: '邀请新成员',
    processingInvitationLink: '邀请处理中，请等待...',
    acceptInvitationSuccess: '已接受邀請',
    wrongUserInvitation1:
        '嘗試接受邀請時出錯。也許邀請已被接受，或者您與錯誤的用戶建立了聯繫。您當前連接為 ',
    wrongUserInvitation2:
        '。請驗證邀請的電子郵件，然後在必要時使用正確的用戶登錄並重試。',
    name: '名称',
    postalCode: '邮政编码',
    owner: '所有者',
    sureToDeleteContent: '删除的场所: ',
    sureToUndeleteContent: '取消删除的场所: ',
    euroPerKwhBuy: '每千瓦时购买价格',
    euroPerKwhSell: '每千瓦时销售价格',
    kgco2PerKwh: '公斤二氧化碳每千瓦时',
    capacity: '容量',
    installationDate: '安装日期',
    kwLimit: '最大电网 kW 限制 用於OCPP_Gateway計費',
    kwhEuro: '元/千瓦时',
    switchesInstalled: '开关已经安装',
    unlimited: '无限制',
    switchInstallationNotAllowed:
        '不允许安装新开关,请联系客服，升级您的云使用计划',
    switchList: '开关列表',
    addSwitch: '添加新开关',
    priority: '优先级',
    readyAt: '准备',
    offFrom: '从',
    offTo: '到',
    assignedDevice: '指定设备',
    assignedPhase: '指定相',
    usageThresholdAlert: '能耗使用',
    alwaysOnAlert: '一直开',
    dataMissingAlert: '数据丢失',
    next: '下一步 >',
    back: '< 返回',
    finish: '完成',
    switchModel: '类型',
    switchName: '名称',
    switchIotAddress: '物联网网关地址',
    switchSSID: '本地Wifi名称',
    switchWifiPassword: '本地Wifi密码',
    switchInstallationStep2:
        "关闭手机移动数据,插上开关,将手机连接到开关的wifi(如shelly-XXX),然后按'下一步'",
    switchInstallationStep3: "再将手机切换连接到本地wifi,然后按'下一步'",
    switchInstallationStep4:
        '您的开关配网成功,可以与用电设备配合使用。下一步将会看到配置表单。',
    editRelay: '编辑继电器',
    editSwitch: '编辑开关',
    relayMode: '类型',
    relayDevice: '继电器',
    relayPhase: '相',
    relayPriority: '优先级',
    relayReadyAt: '准备',
    relayOffFrom: '关闭',
    relayOffTo: '关闭至',
    deleteSwitch: '删除开关',
    confirmDeleteSwitch: '您确认删除该开关?',
    reconfig: '重新配置',
    modbusId: '总线编号',
    ski: 'SKI',
    detail
};